const router = [
    {
        path: '/company/list',
        component: () => import('../views/Company/List.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/company/agenSort',
        component: () => import('../views/Company/AgenSort.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/company/listingSort',
        component: () => import('../views/Company/ListingSort.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/company/map',
        component: () => import('../views/Company/Map.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        }
    },
    {
        path: '/company/detail',
        component: () => import('../views/Company/Detail.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/company/remark',
        component: () => import('../views/Company/Remark.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/company/good',
        component: () => import('../views/Company/Good.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/company/bad',
        component: () => import('../views/Company/Bad.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },

]

export default router